const getImageUrl = (imagePath) => {
  if (!imagePath) return null;

  const baseUrl = import.meta.env.VITE_BACKEND_URL || 'https://api.sewaapartementheedgebylia.my.id';

  // If already a full URL (external or correct base), return as is
  if (imagePath.startsWith('http')) {
    // If it's external URL (unsplash, etc), keep it
    if (!imagePath.includes('localhost')) {
      return imagePath;
    }
    // If it's localhost but wrong port, fix it
    return imagePath.replace(/http:\/\/localhost:\d+/, baseUrl);
  }

  // Remove leading slash if exists
  const cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;

  // If path already contains 'storage/', don't add it again
  if (cleanPath.startsWith('storage/')) {
    return `${baseUrl}/${cleanPath}`;
  }

  return `${baseUrl}/storage/${cleanPath}`;
};

export default getImageUrl;